import React, { FC } from 'react';
import { MenuItem, Select } from '@material-ui/core';
import useLocales from 'hooks/useLocales';
import {
  DEFAULT_ORDERING,
  ORDER_BY_OPTIONS,
  ScoreOrdering
} from 'core/constants/ordering';

import './Index.scss';

interface OrderBySelectProps {
  value?: ScoreOrdering;
  onChange: (value: ScoreOrdering) => void;
  className?: string;
  options?: { value: ScoreOrdering; label: string }[];
}

const OrderBySelect: FC<OrderBySelectProps> = ({
  value = DEFAULT_ORDERING,
  onChange,
  className = '',
  options = ORDER_BY_OPTIONS
}): JSX.Element => {
  const { t } = useLocales();

  return (
    <div className={`order-by-select ${className}`.trim()}>
      <span className="order-by-select__label">{t('Order by')}</span>
      <Select
        value={value}
        className="order-by-select__control"
        onChange={(e) => onChange(e.target.value as ScoreOrdering)}
        inputProps={{ 'aria-label': t('Order by') }}
      >
        {options.map((option) => (
          <MenuItem value={option.value} key={option.value}>
            {t(option.label)}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default OrderBySelect;
